/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.14.0
 * @since 1.14.0
 */

import styled from 'styled-components';

import { RadioButtonContainerStyled } from '../../../../components/common/RadioButton/styled/RadioButtonStyled';

export const WizardAdditionalAccountsStyled = styled.div.attrs({
    className: 'wizard-additional-accounts',
})`
    display: grid;
    grid-template-columns: 1fr 1fr;

    .wizard-additional-accounts__radio-button {
        margin-top: 32px;
    }

    .wizard-additional-accounts__checkbox {
        margin-top: 20px;
        margin-left: 32px;
    }

    .wizard-additional-accounts__agreement-link {
        display: flex;
        margin-top: 32px;
    }

    ${RadioButtonContainerStyled} {
        > input + label {
            pointer-events: none;
        }
    }
`;


